import { boot } from "quasar/wrappers";
import { MsgBox } from "~/components/MsgBox";
export default boot(({ app }) => {
    MsgBox.configure(options => {
        options.title = "Minitech.MyPage";
    });
});
